var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.4927 28.2115C15.6887 28.017 16.0053 28.0182 16.1998 28.2142L26.9259 39.0227L26.2161 39.7271L15.49 28.9186C15.2955 28.7226 15.2967 28.406 15.4927 28.2115V28.2115Z","fill":"current","key":0}),React.createElement("path",{"d":"M48.3533 18.2199C48.5484 18.4153 48.5483 18.7319 48.3529 18.927L27.5829 39.6734C27.1922 40.0637 26.559 40.0633 26.1687 39.6726V39.6726L47.6462 18.2195C47.8415 18.0244 48.1581 18.0245 48.3533 18.2199V18.2199Z","fill":"current","key":1})]);
}

CheckmarkInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"black"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
